export var StorageKeys = /*#__PURE__*/ function(StorageKeys) {
    StorageKeys["Token"] = "GW_USER_TOKEN";
    StorageKeys["Credentials"] = "GW_USER_CREDENTIALS";
    StorageKeys["FboToken"] = "GW_FBO_TOKEN";
    StorageKeys["SiteConfig"] = "GW_SITE_CONFIG";
    StorageKeys["RestrictedGuest"] = "GW_RESTRICTED_GUEST";
    StorageKeys["JobVendorCreds"] = "JOB_VENDOR_CREDS";
    StorageKeys["ActivityCreationToken"] = "ACTIVITY_CREATION_TOKEN";
    StorageKeys["ScheduledMaintenance"] = "SCHEDULED_MAINTENANCE";
    return StorageKeys;
}({});
